import { CARD_NAVIGATION } from "../store/types";

export const Dispatach_Card_Navigation = (dispatch, payload) => {
  dispatch({
    type: CARD_NAVIGATION,
    payload: payload,
  });
};
